import { ENVIRONMENT_CDN_BASE_PATH } from '@spa/constants/cdnPaths';

// Must run before App is imported - Vite resolves dynamic import URLs
// (via __vite_mapDeps) at module evaluation time, before any component mounts.
window.b2b = {
  ...window.b2b,
  __get_asset_location: (filename: string) => {
    const environment = window.B3?.setting?.environment ?? 'production';
    return `${
      ENVIRONMENT_CDN_BASE_PATH[environment] ??
      ENVIRONMENT_CDN_BASE_PATH.production
    }${filename}`;
  },
};
